// eslint-disable-next-line no-undef
export const env = { ...process.env, ...window["env"] };
